/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateActivityDto
 */
export interface CreateActivityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateActivityDto
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateActivityDto
     */
    dateDeadline?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityDto
     */
    summary?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateActivityDto
     */
    resId?: number;
}

/**
 * Check if a given object implements the CreateActivityDto interface.
 */
export function instanceOfCreateActivityDto(value: object): value is CreateActivityDto {
    return true;
}

export function CreateActivityDtoFromJSON(json: any): CreateActivityDto {
    return CreateActivityDtoFromJSONTyped(json, false);
}

export function CreateActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateActivityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
        'dateDeadline': json['date_deadline'] == null ? undefined : (new Date(json['date_deadline'])),
        'summary': json['summary'] == null ? undefined : json['summary'],
        'resId': json['res_id'] == null ? undefined : json['res_id'],
    };
}

export function CreateActivityDtoToJSON(json: any): CreateActivityDto {
    return CreateActivityDtoToJSONTyped(json, false);
}

export function CreateActivityDtoToJSONTyped(value?: CreateActivityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'date_deadline': value['dateDeadline'] == null ? value['dateDeadline'] : value['dateDeadline'].toISOString(),
        'summary': value['summary'],
        'res_id': value['resId'],
    };
}

